import { createSelector } from 'reselect'

import Path from 'webmango-utils/path'

import * as Config from './config'
import * as Status from './status'
import * as RunSection from './runsection'
import * as SelectFile from './file'

const getDataDirectory = Config.getDataDirectory
const getFiles = SelectFile.getAllList

export const getNodeStatuses = Status.getAll

export const getNodeStatus = Status.get

export const getStages = Status.getStages

export const getRunSections = RunSection.getAll

export const getNodeRunSection = RunSection.get

export const getNodeRunFiles = createSelector([ getDataDirectory, RunSection.get ], (dataDirectory, runSection) => {
  if (!runSection) return { input: '', output: '' }
  return {
    input: Path.join(dataDirectory, `${runSection.input_file_name}.${runSection.input_extension}`),
    output: Path.join(dataDirectory, `${runSection.output_file_name}.${runSection.output_extension}`)
  }
})

export const getNodeRunFilesExist = createSelector([ getFiles, getDataDirectory, RunSection.get ], (files, dataDirectory, runSection) => {
  const dataFiles = files[dataDirectory] || []
  return Object.assign({}, {
    get input () {
      if (!runSection) return false
      const input = Path.join(dataDirectory, `${runSection.input_file_name}.${runSection.input_extension}`)
      const inputAlt = Path.join(dataDirectory, `${runSection.input_file_name}_${runSection.input_extension}`)
      return dataFiles.some(({ path }) => {
        return (
          path === input ||
          path === inputAlt
        )
      })
    },
    get output () {
      if (!runSection) return false
      const output = Path.join(dataDirectory, `${runSection.output_file_name}.${runSection.output_extension}`)
      const outputAlt = Path.join(dataDirectory, `${runSection.output_file_name}_${runSection.output_extension}`)
      return dataFiles.some(({ path }) => {
        return (
          path === output ||
          path === outputAlt
        )
      })
    }
  })
})



// WEBPACK FOOTER //
// ../webmango-core/selectors/index.js